"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Onboarding = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("@mui/material/Modal"));
var _Card = _interopRequireDefault(require("@mui/material/Card"));
var _CardHeader = _interopRequireDefault(require("@mui/material/CardHeader"));
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _CardActions = _interopRequireDefault(require("@mui/material/CardActions"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _NavigateNext = _interopRequireDefault(require("@mui/icons-material/NavigateNext"));
var _NavigateBefore = _interopRequireDefault(require("@mui/icons-material/NavigateBefore"));
var _Done = _interopRequireDefault(require("@mui/icons-material/Done"));
var _reactI18next = require("react-i18next");
var _reactRouterDom = require("react-router-dom");
var _reactJoyride = _interopRequireDefault(require("react-joyride"));
var _Lens = _interopRequireDefault(require("@mui/icons-material/Lens"));
var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));
var _system = require("@mui/system");
var _styles = require("@mui/material/styles");
var _templateObject;
var Beacon = function Beacon(_ref) {
  var onClick = _ref.onClick,
    onMouseEnter = _ref.onMouseEnter;
  var theme = (0, _styles.useTheme)();
  var ref = (0, _react.useRef)(null);
  var pulse = (0, _system.keyframes)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  0% {\n    transform: scale(1);\n  }\n  10% {\n    transform: scale(1.1)\n  }\n  20% {\n    transform: scale(1.15)\n  }\n  30% {\n    transform: scale(1.2)\n  }\n  40% {\n    transform: scale(1.25)\n  }\n  50% {\n    transform: scale(1.3)\n  }\n  70% {\n    transform: scale(1.35)\n    background-color: ", ";\n  }\n"])), theme.palette.error.light);
  return /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    size: "small",
    ref: ref,
    sx: {
      animation: "".concat(pulse, " 1s ease-in-out infinite"),
      border: "2px solid ".concat(theme.palette.error.light)
    },
    onClick: onClick,
    onMouseOver: function onMouseOver() {
      return ref.current.style.border = "2px solid ".concat(theme.palette.error.main);
    },
    onMouseOut: function onMouseOut() {
      return ref.current.style.border = "2px solid ".concat(theme.palette.error.light);
    }
  }, /*#__PURE__*/_react.default.createElement(_Lens.default, {
    sx: {
      color: theme.palette.error.main
    }
  }));
};
var Tooltip = function Tooltip(_ref2) {
  var continuous = _ref2.continuous,
    index = _ref2.index,
    step = _ref2.step,
    size = _ref2.size,
    backProps = _ref2.backProps,
    closeProps = _ref2.closeProps,
    primaryProps = _ref2.primaryProps,
    tooltipProps = _ref2.tooltipProps,
    skipProps = _ref2.skipProps,
    isLastStep = _ref2.isLastStep;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(_Card.default, tooltipProps, /*#__PURE__*/_react.default.createElement(_CardHeader.default, {
    title: t(step.title)
  }), /*#__PURE__*/_react.default.createElement(_CardContent.default, null, step.content), /*#__PURE__*/_react.default.createElement(_CardActions.default, {
    sx: {
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    color: "warning",
    variant: "outlined"
  }, skipProps), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "skip"
  }, t('skip'))), index > 0 && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: "outlined",
    startIcon: /*#__PURE__*/_react.default.createElement(_NavigateBefore.default, null)
  }, backProps), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "back"
  }, " Back ")), isLastStep && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: "contained",
    color: "success",
    endIcon: /*#__PURE__*/_react.default.createElement(_Done.default, null)
  }, primaryProps), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "done"
  }, t('done'), " (", index + 1, "/", size, ")")), continuous && !isLastStep && /*#__PURE__*/_react.default.createElement(_Button.default, Object.assign({
    variant: "contained",
    endIcon: /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null)
  }, primaryProps), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "next"
  }, t('next'), " (", index + 1, "/", size, ")")), !continuous && /*#__PURE__*/_react.default.createElement(_Button.default, closeProps, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "next"
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    id: "close"
  }))));
};
var Onboarding = function Onboarding(_ref3) {
  var _ref3$isHome = _ref3.isHome,
    isHome = _ref3$isHome === void 0 ? true : _ref3$isHome;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(true),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    run = _useState4[0],
    setRun = _useState4[1];
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var data = [{
    target: '.app-toggle-theme',
    content: t('toggle theme, toggle between light and dark mode')
  }, {
    target: '.app-switch-language',
    content: t('switch languages, switch to various languages')
  }, {
    target: '.app-bookmark-browse',
    content: t('browse bookmarks, browse and navigate to saved bookmarks')
  }, {
    target: '.app-bookmark-edit',
    content: t('add or remove bookmarks')
  }, {
    target: '.app-share',
    content: t('share report with others')
  }, {
    target: '.app-filter-menu',
    content: t('apply filters')
  }, {
    target: '.app-navigate-next',
    content: t('Next market or next variety')
  }, {
    target: '.app-navigate-previous',
    content: t('Previous market or next variety')
  }, {
    target: '.app-floating',
    content: t('Navigate to market/variety selection')
  }, {
    target: '.recharts-responsive-container',
    content: t('analyse the data from visualization')
  }, {
    target: '.data-list-item',
    // FIXME: Issue with placement
    content: t('the data on the day, click/tap for more information'),
    isFixed: true
  }, {
    target: '.data-list-collapse',
    content: t('More information')
  }, {
    target: 'footer',
    content: t('Read useful information')
  }];
  if (!isHome) {
    data = [{
      target: '#market .MuiChip-label',
      content: t('Select market')
    }, {
      target: '#selection .MuiChip-label',
      content: t('Select variety')
    }, {
      target: 'footer',
      content: t('Get information about selected market and variety')
    }, {
      target: '.app-floating',
      content: t('Complete the selection')
    }];
  }
  var handleCallback = function handleCallback(data) {
    if (isHome && data.index === data.size - 1) {
      navigate('/');
    }
  };
  return /*#__PURE__*/_react.default.createElement(_reactJoyride.default, {
    callback: handleCallback,
    steps: data,
    run: run,
    scrollToFirstStep: true,
    continuous: true,
    hideCloseButton: true,
    showSkipButton: true,
    showProgress: true,
    tooltipComponent: Tooltip,
    beaconComponent: Beacon,
    styles: {
      options: {
        zIndex: 10000
      }
    }
  });
};
exports.Onboarding = Onboarding;